import {GET_ALL_SHARES} from "../actionTypes";

const allLikeShare = (state = [], action) => {
    switch (action.type) {
        case GET_ALL_SHARES:
            return action.payload;

        default:
            return state;
    }
};

export default allLikeShare;
